import { rgba } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";
import type { IDropDownItem } from "@similarweb/ui-components";
import { CheckboxIcon, MultiSelectCategoryDropdownItem } from "@similarweb/ui-components";
import styled, { css } from "styled-components";

const ellipsisDropdownItemActiveStyle = css<IDropDownItem>`
    &:hover {
        background-color: ${rgba(colorsPalettes.carbon[500], 0.05)};
    }

    &:active {
        background-color: ${colorsPalettes.bluegrey[100]};
    }

    ${({ selected }) =>
        selected &&
        css`
            background-color: ${colorsPalettes.bluegrey[100]};
        `}
`;

export const StyledMultiSelectCategoryDropdownItem = styled(MultiSelectCategoryDropdownItem)`
    ${ellipsisDropdownItemActiveStyle};

    font-size: 14px;

    ${CheckboxIcon} {
        padding-left: 8px;
    }
`;
